import { msg } from '@lingui/core/macro';

export const SHARED_EVALUATION_LOG_PAGE_TITLE = msg`Evaluation log`;
export const SHARED_EVALUATION_LOG_PRINT = msg`Print history`;
export const SHARED_EVALUATION_LOG_REFERENCE = msg`Reference`;
export const SHARED_EVALUATION_LOG_EVIDENCE_LABEL = msg`Evidence file`;
export const SHARED_EVALUATION_LOG_DEFAULT_EVIDENCE_NAME = msg`Uploaded evidence`;
export const SHARED_EVALUATION_LOG_NOT_PROVIDED = msg`Not provided`;
export const SHARED_EVALUATION_LOG_NO_COMMENT = msg`No comment provided`;
export const SHARED_EVALUATION_LOG_REMOVE = msg`Remove`;
export const SHARED_EVALUATION_LOG_ASSESSEE_COMMENTS = msg`Assessee's Comments`;
export const SHARED_EVALUATION_LOG_REASON_FOR_EXEMPTION = msg`Reason for Exemption`;
export const SHARED_EVALUATION_LOG_ASSESSOR_COMMENTS = msg`Assessor's Comments`;
export const SHARED_EVALUATION_LOG_EXEMPTION_REQUESTED = msg`Exemption Requested`;
export const SHARED_EVALUATION_LOG_ASSESSOR_EVALUATION = msg`Assessor Evaluation`;
export const SHARED_EVALUATION_LOG_EXEMPTED = msg`Exempted`;
export const SHARED_EVALUATION_LOG_EXEMPTION_REJECTED = msg`Exemption rejected`;
export const SHARED_EVALUATION_LOG_SUBMITTED = msg`Submitted`;
export const SHARED_EVALUATION_LOG_REDO = msg`Redo`;
export const SHARED_EVALUATION_LOG_CLOSED = msg`Closed`;
export const SHARED_EVALUATION_LOG_DISAPPROVED = msg`Disapproved`;
export const SHARED_EVALUATION_LOG_APPROVED = msg`Approved`;
